<script lang="ts">
  import Button from "../../common/form/Button.svelte";
  import { signOut } from "../../../app/api";
  import {
    isCurrentUserLoaded,
    userInfoStore,
    UserInfo,
    Subscription,
    setUserInfo,
  } from "../../../app/store/store-user";
  import {
    getUserSecrets,
    sendDemoEmail,
    sendDemoSMS,
    cancelSubscription,
    getCurrentSubscription,
    changeUserVanityName,
  } from "../../../app/api";

  let userSecrets: any;
  let user: UserInfo;
  let subscription: Subscription;
  async function getUserSecretsInfomation() {
    // userSecrets = await getUserSecrets();
  }

  async function onCancelSubscription() {
    if (!subscription && !subscription.id) return;

    await cancelSubscription(subscription.id, {
      onSuccess: async () => {
        // console.log("cancel subscription success ====== ");
        await setUserInfo({ ...user, plan: "" });
      },
      onError: async (error) => {
        console.log("cancel subscription error ", error);
      },
    });
  }

  let emailMessage = "";
  let emailMessageError: string = "Send message to your email.";
  let isSending: boolean = false;
  async function sendEmail() {
    if (!emailMessage) {
      emailMessageError = "Email content cannot be empty!";
      return;
    }
    if (isSending) return;
    emailMessageError = "Sending ...";
    isSending = true;
    emailMessageError = await sendDemoEmail({ message: emailMessage });
    isSending = false;
  }

  let smsMessage = "";
  let recepient = "";
  let smsMessageError = "Sending your sms";
  let isSendingSMS: boolean = false;
  async function sendSMS() {
    if (!smsMessage || !recepient) {
      smsMessageError = "Message and recepient can not be empty!";
      return;
    }
    if (isSendingSMS) return;
    smsMessageError = "Sending ...";
    isSendingSMS = true;
    // console.log("message to send ==== ", { message: smsMessage, recepient });
    smsMessageError = await sendDemoSMS({ message: smsMessage, recepient });
    isSendingSMS = false;
  }

  async function getUserSubscription() {
    await getCurrentSubscription({
      onSuccess: async (data) => {
        console.log("data subscription ==== ", data);
        subscription = data.subscription;
      },
    });
  }

  let vanityName: string = "";
  async function handleChangeVanityName() {
    await changeUserVanityName(vanityName, {
      onSuccess: async (data) => {
        console.log("success change vanity name ==== ", data);
        const userRecord = data.user;
        setUserInfo({ ...userRecord });
      },
      onError: async (error) => {
        console.log("error change vanity name ==== ", error);
      },
    });
  }

  $: user = $userInfoStore;
  $: isLoaded = $isCurrentUserLoaded;
  $: if (user) {
    getUserSecretsInfomation();
    getUserSubscription();
  }
</script>

{#if user}
  <div class="pl-20">
    {#if !isLoaded}
      <div class="text-[20px]">Loading ...</div>
    {:else if user}
      <div class="text-[20px]">Email: {user.email}</div>
      <div class="text-[20px]">
        Name: {user.firstName + " " + user.lastName}
      </div>
      <div>Vanity name: {user.vanityName}</div>
      <hr />
      <h2 class="text-dark-200 text-2xl">Subscription Plan:</h2>
      <br />
      {#if subscription && subscription.items.length > 0}
        {#if subscription.items[0]}
          {@const item = subscription.items[0]}
          <div class="pl-2 text-[16px] text-dark-200">
            <div>Account type: <b>{item.lookup_key.split("_")[0]}</b></div>
            <div>Plan tier: <b>{item.lookup_key.split("_")[1]}</b></div>
            <div>Recurring period: <b>{item.lookup_key.split("_")[2]}</b></div>
            <div>Base price: <b>$ {item.unit_amount / 100}</b></div>
          </div>
        {/if}
        <br />
        {#if subscription.items[1]}
          {@const item = subscription.items[1]}
          <div class="pl-2 text-[16px] text-dark-200">
            <div>Number of licenses: <b>{item.quantity}</b></div>
            <div>License price: <b>$ {item.unit_amount / 100}</b></div>
          </div>
        {/if}
      {/if}
      <!-- {#if subscription}
        <br />
        <Button on:click={onCancelSubscription}>Cancel Subscription</Button>
      {/if}
      <hr /> -->
      <!--     
    <div class="py-10">
      <textarea
        bind:value={emailMessage}
        placeholder="Enter your message"
        class="p-3"
        name="email content"
        cols="30"
        rows="10"
      />
      <div>{emailMessageError}</div>
      <Button on:click={sendEmail}>Send email</Button>
    </div>

    <hr />

    <div class="py-10">
      <div class="pb-3">
        <span>Phone number:</span>
        <input class="p-2" bind:value={recepient} type="tel" />
      </div>
      <textarea
        bind:value={smsMessage}
        name="sms mesage"
        class="p-3"
        placeholder="Enter your message"
        cols="30"
        rows="10"
      />
      <div>{smsMessageError}</div>
      <Button on:click={sendSMS}>Send SMS</Button>
    </div>
    <hr />
    {#if userSecrets}
      <div class="text-[20px]">api_key: {userSecrets.data.api_key}</div>
      <div class="text-[20px]">db_host: {userSecrets.data.db_host}</div>
    {/if}
    <br />
  -->
      <br />
      <div>
        <div>
          Vanity name <input class="p-2" bind:value={vanityName} type="text" />
        </div>
        <br />
        <Button on:click={handleChangeVanityName}>Change vanityName</Button>
      </div>
      <br />
      <Button on:click={signOut}>Sign Out</Button>
    {:else}
      <div class="text-[20px]">Loading ...</div>
    {/if}
  </div>
{/if}

<style lang="postcss">
  b {
    @apply text-dark-300;
  }
</style>
